import _DatabaseModel, { i18n } from "./_DatabaseModel";

const SERVICES_TAB_ASSETS = 139;
const SERVICES_TAB_DOCUMENTS = 140;
const SERVICES_TAB_ISSUES = 141;
const SERVICES_TAB_PERSONS = 142;
const SERVICES_TAB_SLA = 143;
const SERVICES_TAB_TEMPLATES = 144;
const SERVICES_TAB_WORKFLOW = 145;
const SERVICES_TAB_ISSUE_CATEGORIES = 175;

class Service extends _DatabaseModel {
  static model = "service";
  static showSize = 8;
  static editDialogComponent = "services-edit-dialog";
  static createNewObject = {
    object: {
      definition: {
        color: "#8E39C2FF",
        task_types: ["general"],
        autoclose_time: 30,
        working_hours: {
          monday: { from: "08:00", to: "16:00" },
          tuesday: { from: "08:00", to: "16:00" },
          wednesday: { from: "08:00", to: "16:00" },
          thursday: { from: "08:00", to: "16:00" },
          friday: { from: "08:00", to: "16:00" },
          saturday: false,
          sunday: false,
          holiday: false,
        },
      },
    },
  };

  static tableHeaders = [
    { textKey: "form.label.name", value: "name" },
    { textKey: "form.label.description", value: "description" },
    { text: "", value: "tags", sortable: false },
    { textKey: "form.label.archived_at", value: "discarded_at" },
  ];

  static show = {
    buttons: ["edit"],
    reloadingModels: ["issue", "template_assignment", "issue_category"],
  };

  static filter = {
    parts: {
      fields: [
        "name",
        "issue_type",
        "team_id",
        "contract_id",
        "price_list_id",
        "persistence",
      ],
      extended_fields: ["description", "time_filter"],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static issue_types = ["Incident", "Request", "Problem", "Change"];

  static operations = ["link_to_document", "archive_multiple"];

  static cardFields(object) {
    return {
      title: object.name,
      tags: true,
    };
  }

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.issue_types",
        value: object.definition.issue_types.map((i) =>
          i18n.t(`issue.issue_types.${i}`)
        ),
        type: "list",
      },
      {
        labelKey: "team.team",
        value: object.team,
        type: "link",
        to: "teams",
      },
      {
        labelKey: "form.label.owner",
        value: object.owner?.person,
        type: "link",
        to: "persons",
      },
      {
        labelKey: "contract.contract",
        value: object.contract,
        type: "link",
        to: "contracts",
      },
      {
        labelKey: "price_list.price_lists",
        value: object.price_lists,
        type: "link_array",
        to: "price_lists",
      },
      {
        labelKey: "service_link.label.service_links_for_incident",
        value: object.supporting_services,
        type: "link_array",
        to: "services",
        condition: !!object.definition?.issue_types?.includes("Incident"),
      },
      {
        labelKey: "service.label.allowed_tags",
        value: object.definition?.tag_definitions,
        type: "tags",
      },
      {
        labelKey: "sla.label.autoclose_time",
        value: object.definition?.autoclose_time
          ? `${object.definition.autoclose_time} ${i18n.tc("day_l", object.definition.autoclose_time)}`
          : "",
        type: "plain",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
      {
        labelKey: "form.label.archived_at",
        value: object.discarded_at,
        type: "date_time",
        condition: object.discarded_at,
      },
    ];
  }

  static submenuActions = [
    this.commonActions.duplicate,
    this.commonActions.createIssue,
    this.commonActions.manageSubscriptions,
    // this.commonActions.permittedPersons,
    this.commonActions.openActivities,
    this.commonActions.archive,
  ];

  static archivedActions = [
    this.commonActions.restore,
    this.commonActions.delete,
  ];

  static tabs = [
    this.detailTab,
    {
      titleKey: "person.persons",
      permission: SERVICES_TAB_PERSONS,
      component: "ServicePersonsTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "sla.sla",
      permission: SERVICES_TAB_SLA,
      component: "ServiceSlaTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "service.label.workflow",
      permission: SERVICES_TAB_WORKFLOW,
      component: "WorkflowTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "template.templates",
      permission: SERVICES_TAB_TEMPLATES,
      component: "TemplatesAssignmentsTab",
      parameters: { entity_type: "Service" },
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "service.label.issue_categories",
      permission: SERVICES_TAB_ISSUE_CATEGORIES,
      component: "ServiceIssueCategoriesTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "issue.issues",
      permission: SERVICES_TAB_ISSUES,
      component: "IssuesTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "asset.assets",
      permission: SERVICES_TAB_ASSETS,
      component: "AssetsOnServiceTab",
      disabled: this.defaultDisabledTab(),
    },
    {
      titleKey: "document.documents",
      permission: SERVICES_TAB_DOCUMENTS,
      component: "DocumentsTab",
      disabled: this.defaultDisabledTab(),
    },
  ];
}

export default Service;
